import { Link, useHistory } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import api from '../api/api';
import { KioskTimeConfig } from './kioskTimeConfig';
import QRCode from 'react-qr-code';
import Modal from 'react-bootstrap/Modal';
import stringHelpers from '../../utilities/stringHelpers';
import UploadFile from '../shared/file-uploader';
import { ErrorModal } from "../../utilities/errorModal";
import Loader from '../shared/loader';
import roleUtilities from '../../utilities/roleUtilities';
import { MinutesInputWithUnit } from '../shared/minutesInputWithUnit';
import { minutesToUnit } from '../../utilities/dateUtilities';
import Enums from '../../utilities/enum';

export default function KioskDetails(props) {
    const history = useHistory()
    
    const [site, setSite] = useState(null);
    const [kiosk, setKiosk] = useState(null);
    const [kioskEditMode, setKioskEditMode] = useState(false);
    const [kioskName, setKioskName] = useState(null);
    const [shortCode, setShortCode] = useState(null);
    const [webKioskEnabled, setWebKioskEnabled] = useState(null);
    const [kioskAppEnabled, setKioskAppEnabled] = useState(null);
    const [timeSpanRows, setTimeSpanRows] = useState([]);
    const [hideExpiryDate, setHideExpiryDate] = useState(null)
    const [showBlueBadgeNumber, setShowBlueBadgeNumber] = useState(false)
    const [addEntriesToClient, setAddEntriesToClient] = useState(false)
    const [kioskUrl, setKioskUrl] = useState(null);
    const [logoAttachment, setLogoAttachment] = useState(null)
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [maxStayMinutes, setMaxStayMinutes] = useState(null);
    const [noReturnWithinMinutes, setNoReturnWithinMinutes] = useState(null);

    const kioskBaseUrl = `https://kiosk.advancedparking.tech/${ props.organisationId }/sites/${ props.match.params.siteId }`
    const svgRef = useRef();
    const fetchKiosk = () => {
        api.getSite(
            data => setSite(data),
            () => { },
            props.match.params.siteId,
            props.organisationId,
            props.token
        )
        api.getKioskById(
            data => {
                setKiosk(data);
                setKioskName(data.name)
                setKioskAppEnabled(data.isAppEnabled);
                setWebKioskEnabled(data.isWebEnabled);
                setHideExpiryDate(data.hideExpiryDate)
                setLogoAttachment(data.logoAttachment)
                setShowBlueBadgeNumber(data.showBlueBadgeNumber)
                setAddEntriesToClient(data.addEntriesToClient)
                setMaxStayMinutes(data.maxStayMinutes)
                setNoReturnWithinMinutes(data.noReturnWithinMinutes)
                if (data.timeSpans){
                    setTimeSpanRows(data.timeSpans)
                }
                if (data.shortCode) {
                    setKioskUrl(`${ kioskBaseUrl }/${ data.shortCode }`)
                    setShortCode(data.shortCode);
                } else {
                    setKioskUrl(kioskBaseUrl)
                }
            },
            () => { },
            props.organisationId,
            props.match.params.siteId,
            props.match.params.kioskId,
            props.token
        )
    }

    const regenerateKioskShortCode = () => {
        api.regeneateKioskShortCode(
            props.organisationId, props.match.params.siteId, props.match.params.kioskId,
            data => {
                if (data.shortCode) {
                    setKioskUrl(`${ kioskBaseUrl }/${ data.shortCode }`)
                    setShortCode(data.shortCode);
                } else {
                    setKioskUrl(kioskBaseUrl)
                }
                setShowModal(false)
            },
            error => console.log(error),
            props.token
        )
    }

    useEffect(() => fetchKiosk(), [])

    const handleKioskConfigurationUpdate = () => {
        setIsLoading(true)
        api.updateKioskConfiguration(
            props.organisationId, props.match.params.siteId, kioskName, props.match.params.kioskId,
            kioskAppEnabled, webKioskEnabled, timeSpanRows, logoAttachment?.id, hideExpiryDate, showBlueBadgeNumber, addEntriesToClient, maxStayMinutes, noReturnWithinMinutes,
            data => {
                if (data.isError) {
                    setError(data.errorMessage)
                } else {
                    fetchKiosk()
                    setIsLoading(false)
                }
            },
            error => { 
                console.log(error)
                setError(error.errorMessage)
                setIsLoading(false)
            },
            props.token
        )
    }

    const updateTimeSpanRow = (id, value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) => {

        setTimeSpanRows(timeSpanRows
            .toSpliced(
                id, 1, 
                { 
                    type: mode, 
                    duration: value, 
                    label: !stringHelpers.isNullOrEmpty(customLabel) ? customLabel : null, 
                    startTimeDeltaMinutes: startTimeDeltaMinutes, 
                    endOfDayDeltaMinutes: endOfDayDeltaMinutes,
                    maximumTimeOfDay: maximumTimeOfDay
                }
            )
        )
    }

    const handleQRDownload = () => {
        if (svgRef.current) {
            const serializer = new XMLSerializer();
            const blob = new Blob([serializer.serializeToString(svgRef.current)], {type: "image/svg+xml"});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'qr-code.svg';
            link.click();
        }
    }
    const isThirdPartyUser = roleUtilities.isThirdPartyManager(props.user, props.organisationId) || roleUtilities.isThirdPartyProcessor(props.user, props.organisationId)

    const handleKioskDelete = () => {
        api.deleteSiteKiosk(
            data => {
                if (data.isError) {
                    setShowDeleteModal(false)
                    setError(data.errorMessage)
                } else {
                    history.push(`/organisation/${ props.organisationId }/client/${ site.clientId }/site/${ props.match.params.siteId }`)
                }
            },
            error => {
                setShowDeleteModal(false)
                setError(error.message)
            },
            props.organisationId, props.match.params.siteId, props.match.params.kioskId, props.token
        )
    }

    const maxStayDisplay = minutesToUnit(maxStayMinutes)
        const noReturnDisplay = minutesToUnit(noReturnWithinMinutes)
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    {
                        site && kiosk &&
                        <div className="card mb-3">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">{ kiosk.name }</h5>
                                    </div>
                                    <Link to={ `/organisation/${ props.organisationId }/client/${ site.clientId }/site/${ props.match.params.siteId }` } className="btn btn-falcon-default btn-sm mr-2 py-1" type="button"><i className="fas fa-reply"></i> Back</Link>
                                    {
                                    !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                                    <>
                                        <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                        <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                            <button onClick={() => setShowDeleteModal(true)} type="button" className="dropdown-item text-danger">
                                                <i className="fas fa-times mr-1"></i>Delete Kiosk</button>
                                        </div>
                                    </>}
                                </div>
                            </div>
                        </div>
                    }
                    {
                        kiosk &&
                        <div className="card mb-3">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">Details</h5>
                                    </div>
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className="col-auto">
                                        <button type="button" className="btn btn-primary btn-sm ml-2" onClick={ () => setKioskEditMode(!kioskEditMode) }>
                                            <i className="fas fa-edit"></i> Edit</button>
                                    </div>}
                                </div>
                            </div>


                            <div className="card-body bg-light border-top details-container">
                                {
                                    isLoading
                                    ? <Loader />
                                    : <>
                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Kiosk Name<span className="req"></span></p>
                                                        </div>
                                                        <div className="col-md-6 col-12 px-0">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={ kioskName } onChange={ (e) => setKioskName(e.target.value) } />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Kiosk Name</p>
                                                        </div>
                                                        <p>{ kiosk.name }</p>
                                                    </div>
                                            }
                                        </>

                                        <div className="row">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-3">Code</p>
                                            </div>
                                            <p className='text-monospace'>{ shortCode }</p>
                                        </div>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Logo</p>
                                                        </div>
                                                        <div className="col-md-6 col-12 px-0 d-flex flex-column align-items-start mt-1 mb-3">
                                                            <button className="btn btn-falcon-default my-2" data-toggle="modal" data-target="#add-logo-attachment">Select Logo</button>
                                                            
                                                            {logoAttachment && 
                                                                <div className='position-relative'>
                                                                    <button data-toggle="modal" data-target="#clear-logo-attachment" className='btn p-0 bg-white rounded-circle image-clear'><i className='far fa-times-circle fs-1'></i></button>
                                                                    <img className='rounded border p-1 mb-1' width={200} src={logoAttachment?.url} />
                                                                    <p className='m-0'>{logoAttachment?.filename}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="modal fade save-dialog success-dialog" id="add-logo-attachment" tabIndex="-1" role="dialog">
                                                            <UploadFile onSuccess={(file) => setLogoAttachment(file)} type="Logo" organisationId={props.organisationId} />
                                                        </div>
                                                        <div className="modal fade" id="clear-logo-attachment" tabIndex="-1" role="dialog">
                                                            <div className="modal-dialog" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h4 className="modal-title">Clear logo</h4>
                                                                    </div>
                                                                    <div className="modal-body">Are you sure you want to clear file "{logoAttachment?.filename}"?</div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-falcon-default" data-dismiss="modal">Cancel</button>
                                                                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => setLogoAttachment(null)}>Confirm</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : <div className={`row ${kiosk.logoAttachment ? "mb-3" : ""}`}>
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Logo</p>
                                                        </div>
                                                        <div className='col-md-6 col-12 px-0 d-flex flex-column'>
                                                            {kiosk.logoAttachment && <img className='rounded border p-1 mb-1' width={200} src={kiosk.logoAttachment.url} />}
                                                            <p className='m-0'>{kiosk.logoAttachment?.filename}</p>
                                                        </div>
                                                    </div>
                                            }
                                        </>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Web Kiosk Enabled</p>
                                                        </div>
                                                        <div className="col-md-6 col-12 custom-control custom-switch">
                                                            <input
                                                                disabled={ !kioskEditMode }
                                                                className="custom-control-input"
                                                                type="checkbox"
                                                                id="web-kiosk-enabled"
                                                                checked={ webKioskEnabled }
                                                                onChange={ () => setWebKioskEnabled(!webKioskEnabled) } />
                                                            <label
                                                                className="custom-control-label"
                                                                htmlFor="web-kiosk-enabled"
                                                            ></label>
                                                        </div>
                                                    </div>
                                                    : <div className="row mb-2">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Web Kiosk Enabled</p>
                                                        </div>
                                                        {
                                                            webKioskEnabled && kioskUrl
                                                                ? <div className="col-md-9 col-12 pl-0">
                                                                    <i class="fas fa-check text-success mr-2 my-2"></i>
                                                                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "0.35rem"}}>
                                                                        <a target="_blank" href={ kioskUrl } className="m-0">
                                                                            <h6 className='m-0'>{ kioskUrl }</h6>
                                                                        </a>
                                                                        <button className="btn mx-3 p-0" onClick={ () => navigator.clipboard.writeText(kioskUrl) }>
                                                                            <i className="fas fa-copy" />
                                                                        </button>
                                                                        {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <button className="btn btn-falcon-default btn-sm mr-3 py-1" onClick={ () => setShowModal(true) }>
                                                                            <i className="fas fa-redo mr-2" />
                                                                            Regenerate URL and QR Code
                                                                        </button>}
                                                                    </div>
                                                                    <div className="d-flex">
                                                                        <div style={ { width: "100px", height: "100px", marginTop: "8px" } }>
                                                                            <QRCode ref={svgRef} style={ { height: "auto", maxWidth: "100%", width: "100%" } } value={ kioskUrl } />
                                                                        </div>
                                                                        <button onClick={() => handleQRDownload()} className="btn btn-falcon-default btn-sm ml-2 align-self-end">
                                                                            <i className="fas fa-download mr-2" />
                                                                            Download QR Code
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                : <i class="fas fa-times text-danger mt-1"></i>
                                                        }
                                                    </div>
                                            }
                                        </>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Kiosk App Enabled</p>
                                                        </div>
                                                        <div className="col-md-6 col-12 custom-control custom-switch ">
                                                            <input
                                                                disabled={ !kioskEditMode }
                                                                className="custom-control-input"
                                                                type="checkbox"
                                                                id="kiosk-app-enabled"
                                                                checked={ kioskAppEnabled }
                                                                onChange={ () => setKioskAppEnabled(!kioskAppEnabled) } />
                                                            <label className="custom-control-label" htmlFor="kiosk-app-enabled"></label>
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Kiosk App Enabled</p>
                                                        </div>
                                                        {
                                                            kioskAppEnabled
                                                                ? <i class="fas fa-check text-success mt-1"></i>
                                                                : <i class="fas fa-times text-danger mt-1"></i>
                                                        }
                                                    </div>
                                            }
                                        </>

                                        <>
                                            {
                                                timeSpanRows &&
                                                <div className="row">
                                                    <div className="col-md-3 col-12">
                                                        <p className="font-weight-semi-bold mb-3">Time Spans{kioskEditMode && <span className="req"></span>}</p>
                                                    </div>
                                                    <div className="col-md-2 col-12 pl-0">
                                                        <KioskTimeConfig
                                                            updateList={ newList => setTimeSpanRows(newList) }
                                                            handleAddRow={ (value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) => {
                                                                const payloadValue = (mode === 3 || mode === 4) ? null : value;
                                                                setTimeSpanRows(prevState => [...prevState, { type: parseInt(mode), duration: payloadValue, label: customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay }])
                                                            } }
                                                            handleUpdateRow={ (id, value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) => updateTimeSpanRow(id, value, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, maximumTimeOfDay) }
                                                            handleDeleteRow={ id => setTimeSpanRows(timeSpanRows.toSpliced(id, 1)) }
                                                            data={ timeSpanRows }
                                                            editMode={ kioskEditMode }
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Hide Expiry Date</p>
                                                        </div>
                                                        <div className="col-md-6 col-12 custom-control custom-switch ">
                                                            <input
                                                                disabled={ !kioskEditMode }
                                                                className="custom-control-input"
                                                                type="checkbox"
                                                                id="hide-expiry-date"
                                                                checked={ hideExpiryDate }
                                                                onChange={ () => setHideExpiryDate(!hideExpiryDate) } />
                                                            <label className="custom-control-label" htmlFor="hide-expiry-date"></label>
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Hide Expiry Date</p>
                                                        </div>
                                                        {
                                                            hideExpiryDate
                                                                ? <i class="fas fa-check text-success mt-1"></i>
                                                                : <i class="fas fa-times text-danger mt-1"></i>
                                                        }
                                                    </div>
                                            }
                                        </>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Show Blue Badge Number</p>
                                                        </div>
                                                        <div className="col-md-6 col-12 custom-control custom-switch ">
                                                            <input
                                                                className="custom-control-input"
                                                                type="checkbox"
                                                                id="show-blue-badge-number"
                                                                checked={ showBlueBadgeNumber }
                                                                onChange={ () => setShowBlueBadgeNumber(!showBlueBadgeNumber) } />
                                                            <label className="custom-control-label" htmlFor="show-blue-badge-number"></label>
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Show Blue Badge Number</p>
                                                        </div>
                                                        { showBlueBadgeNumber && <i class="fas fa-check text-success mt-1"></i>}
                                                        {!showBlueBadgeNumber && <i class="fas fa-times text-danger mt-1"></i>}
                                                    </div>
                                            }
                                        </>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Add entries to whole Client</p>
                                                        </div>
                                                        <div className='col-md-6 col-12 custom-control custom-switch'>
                                                            <input
                                                                className="custom-control-input"
                                                                type="checkbox"
                                                                id="add-entries-to-client"
                                                                checked={ addEntriesToClient }
                                                                onChange={ () => setAddEntriesToClient(!addEntriesToClient) } />
                                                            <label className="custom-control-label" htmlFor="add-entries-to-client"></label>
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Add entries to whole Client</p>
                                                        </div>
                                                        <div className='col-md-6 col-12 px-0'>
                                                            { addEntriesToClient && <i class="fas fa-check text-success mt-1"></i>}
                                                            {!addEntriesToClient && <i class="fas fa-times text-danger mt-1"></i>}
                                                        </div>
                                                    </div>
                                            }
                                        </>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row mt-3 mb-1">
                                                        <div className="col-md-3 col-12 ">
                                                            <p className="font-weight-semi-bold mb-1">Maximum Stay</p>
                                                        </div>
                                                        <div className="col-md-6 col-12 d-flex align-items-center px-0">
                                                            <MinutesInputWithUnit
                                                                numberOfMinutes={ maxStayMinutes }
                                                                handleChange={ setMaxStayMinutes }
                                                            />
                                                            <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setMaxStayMinutes(null) }>
                                                                <i className="fas fa-undo mr-1"></i>
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">Maximum Stay</p>
                                                        </div>
                                                        <div className='col-md-6 col-12 px-0'>
                                                            { maxStayDisplay.value } { maxStayDisplay.value !== null && Enums.TimeSpanMode[maxStayDisplay.unit] }
                                                        </div>
                                                    </div>
                                            }
                                        </>

                                        <>
                                            {
                                                kioskEditMode
                                                    ? <div className="row mt-3 mb-1">
                                                        <div className="col-md-3 col-12 ">
                                                            <p className="font-weight-semi-bold mb-1">No return within</p>
                                                        </div>
                                                        <div className="col-md-6 col-12 d-flex align-items-center px-0">
                                                            <MinutesInputWithUnit
                                                                numberOfMinutes={ noReturnWithinMinutes }
                                                                handleChange={ setNoReturnWithinMinutes }
                                                            />
                                                            <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setNoReturnWithinMinutes(null) }>
                                                                <i className="fas fa-undo mr-1"></i>
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-md-3 col-12">
                                                            <p className="font-weight-semi-bold mb-3">No return within</p>
                                                        </div>
                                                        <div className='col-md-6 col-12 px-0'>
                                                            { noReturnDisplay.value } { noReturnDisplay.value !== null && Enums.TimeSpanMode[noReturnDisplay.unit] }
                                                        </div>
                                                    </div>
                                            }
                                        </>

                                        <>
                                            { kioskEditMode && (
                                                <div className="card-footer border-top ">
                                                    <div className="row client-edit-buttons">
                                                        <div className="col-6 col-sm-auto ml-auto pl-0">
                                                            <div id="dashboard-actions">
                                                                <button
                                                                    onClick={ () => {
                                                                        setKioskEditMode(false);
                                                                        fetchKiosk();
                                                                    } }
                                                                    className="btn btn-falcon-default btn-sm">
                                                                    <i className="fas fa-times"></i> Cancel
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    disabled={timeSpanRows.length === 0 || stringHelpers.isNullOrEmpty(kioskName)}
                                                                    className="btn btn-success btn-sm ml-2"
                                                                    onClick={ () => {
                                                                        handleKioskConfigurationUpdate();
                                                                        setKioskEditMode(false)
                                                                    } }>
                                                                    <i className="fas fa-check"></i> Confirm
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) }
                                        </>
                                    </>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>

            <Modal show={ showModal } onHide={ () => { setShowModal(false) } }>
                <Modal.Header>
                    <Modal.Title>
                        Warning
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 ">
                            <p className="font-weight-semi-bold  mt-1 mb-2">If you continue the previous QR Code for this kiosk will no longer work. Are you sure?</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-sm btn-danger mt-1"
                        onClick={ () => { setShowModal(false) } }
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-sm btn-success mt-1"
                        onClick={ () => regenerateKioskShortCode() }
                    >
                        Confirm
                    </button>
                </Modal.Footer>
            </Modal>
            {
                showDeleteModal
                && <Modal show onHide={ () => setShowDeleteModal(false) }>
                    <Modal.Header>
                        <Modal.Title className='text-danger'>
                            Delete Kiosk
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete the kiosk <b>{kioskName}</b>?
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            className="btn btn-falcon-default btn-sm"
                            onClick={ () => setShowDeleteModal(false) }
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-sm btn-danger mt-1"
                            onClick={ handleKioskDelete }
                        >
                            Delete
                        </button>
                    </Modal.Footer>
                </Modal>
            }
            {
                !stringHelpers.isNullOrEmpty(error) &&
                <ErrorModal message={error} onHide={() => setError(null)} />
            }
        </div>
    )
}